// extracted by mini-css-extract-plugin
export default {"ctn":"preAndNext_ctn__6g8Cx","preText":"preAndNext_preText__WPNBZ","nextText":"preAndNext_nextText__GkSkn","icon":"preAndNext_icon__zhvCo"};